import { Select, strIsNullOrEmpty, tryParseJSONObject } from '@fox/atoms';
import React from 'react';
import { CustomFieldEditProps } from '../contracts';

type Options = {
	label: string;
	id: string;
	colour?: string;
};

export interface ISelectMeta {
	colourCoded: boolean;
	options?: Options[];
	deletedOptions?: Options[];
	allowMulti: boolean;
}
export function parseSelectMeta(meta: string): ISelectMeta {
	const parsedMeta = tryParseJSONObject<ISelectMeta>(meta, undefined);
	const defaultMeta = { allowMulti: false, colourCoded: false, options: [], deletedOptions: [] };
	return parsedMeta ?? defaultMeta;
}
export const SelectCustomField: React.FC<CustomFieldEditProps> = ({ customField, onChange }) => {
	const meta = parseSelectMeta(customField.meta);
	const options = meta.options.map(o => ({ id: o.id, label: o.label }));

	return (
		<Select
			multiple={meta.allowMulti}
			label={customField.displayName}
			options={options}
			value={meta.allowMulti ? customField.value ?? [] : customField.value?.[0] ?? []}
			getOptionLabel={(o: { id: string; label: string }) => o?.label ?? ''}
			isOptionEqualToValue={(option, value) => option?.id === value?.id}
			onChange={(_, v) => {
				let newValue;
				if (Array.isArray(v)) {
					const result = [];
					const map = new Map();
					for (const item of v) {
						if (!map.has(item.id)) {
							map.set(item.id, true);
							result.push({
								id: item.id,
								label: item.label
							});
						}
					}
					newValue = result;
				} else {
					newValue = !strIsNullOrEmpty(v) ? [v] : [];
				}
				onChange(customField.customFieldId, newValue);
			}}
		/>
	);
};
